import SpreeMessages from "shared/api/spree/Messages"
export default class Messages extends SpreeMessages {
  static async contact(form, options) {
    const data = await super.contact(form, options);
    return Pervino.Util.Notifier.success(data.message);
  }
};
